import notistack from "modules/core/notistack";
import { postLogin } from "../../../helpers/backend-helper";
import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag, setPermissions } from "./reducer";
import { setAuthorization, setStore } from "helpers/api_helper";
import { HttpStatus } from "modules/core";

// Login Action
export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    const response = await postLogin({
      userName: user.userName,
      password: user.password,
    });
    if (response?.data && response.status === HttpStatus.Success) {
      notistack.notifyFromApi(response);

      const userData = response.data;
      localStorage.setItem("authPOSUser", JSON.stringify(userData));
      localStorage.setItem('isMainStore', userData.isMainStore)
      localStorage.setItem('mayavePurityEdit', userData.isMainStore)
      localStorage.setItem("token", userData.token);
      localStorage.setItem('storedataid', userData.storeId)

      if (userData.token) {
        setAuthorization(userData.token)
      }

      if (userData.storeId) {
        setStore(userData.storeId)
      }

      dispatch(loginSuccess(userData));
      dispatch(setPermissions(userData?.permissions || []));
      history("/dashboard");

    } else {
      notistack.notifyFromApi(response);
      dispatch(apiError("Invalid response"));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

// Logout Action
export const logoutUser = () => async (dispatch: any) => {
  try {
    localStorage.removeItem("authPOSUser");
    localStorage.removeItem("token");
    localStorage.removeItem("storedataid");
    localStorage.clear()
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    return dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError(error));
  }
};
